module.exports = __webpack_public_path__ + "img/cvv.ff6ab365.svg";